import { Controller } from "@hotwired/stimulus";

// Lazily loads Calendly script when needed
export default class extends Controller {
  static targets = ["trigger"];

  connect() {
    // Only load Calendly on mobile devices when the trigger element is visible
    if (this.isMobileDevice()) {
      this.observeTrigger();
    } else {
      // Load immediately on desktop
      this.loadCalendly();
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  observeTrigger() {
    if (!this.hasTriggerTarget) {
      // If no trigger target, load immediately
      this.loadCalendly();
      return;
    }

    // Create intersection observer to watch when trigger becomes visible
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadCalendly();
            this.observer.disconnect();
          }
        });
      },
      {
        rootMargin: "100px", // Load slightly before element comes into view
      }
    );

    this.observer.observe(this.triggerTarget);
  }

  loadCalendly() {
    // Check if Calendly is already loaded
    if (window.Calendly) {
      this.initBadgeWidget();
      return;
    }

    // Load Calendly CSS (deferred)
    const link = document.createElement("link");
    link.href = "https://assets.calendly.com/assets/external/widget.css";
    link.rel = "stylesheet";
    link.media = "print";
    link.onload = function () {
      this.media = "all";
    };
    document.head.appendChild(link);

    // Load Calendly JS
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.type = "text/javascript";
    script.defer = true;

    // Initialize badge widget once script loads
    script.onload = () => {
      this.initBadgeWidget();
    };

    document.head.appendChild(script);
  }

  initBadgeWidget() {
    if (window.Calendly && !this.badgeInitialized) {
      window.Calendly.initBadgeWidget({
        url: "https://calendly.com/d/cv38-y9d-msq/demo-rapido-de-calisto?hide_gdpr_banner=1&hide_event_type_details=1",
        text: "Agenda un demo",
        color: "#fbf26e",
        textColor: "#000000",
        branding: undefined,
      });
      this.badgeInitialized = true;
    }
  }

  isMobileDevice() {
    // Check if viewport is mobile size (matches Tailwind's md breakpoint)
    return window.innerWidth < 768;
  }
}
